module.exports = __webpack_public_path__ + "81a923e2bd978d921df16cc3aceff16b.svg";